import React from 'react';

import { flagStyles } from '../settings';

const SvgCH = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-984px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCH;
